import clsx from 'clsx';
import CourseViewDetailComponent from '~/components/CourseViewDetail';
import styles from './course.module.scss';
import { getAllLanguages } from '~/api/languages';
import { getAllLevels } from '~/api/levels';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import DateTimePicker from 'react-datetime-picker';
import TimePicker from 'react-time-picker';

const type_scores = [{ 0: 'Max Score' }, { 1: 'Final Score' }, { 2: 'Average Score' }];

const MainChild = () => {
    const [openFieldForm, setOpenFieldForm] = useState(true);
    const [openFieldForms, setOpenFieldForms] = useState([]);

    const [theme, setTheme] = useState('');

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const [languages, setLanguages] = useState([]);
    const [languages_, setLanguages_] = useState([]);
    const [openLanguages, setOpenLanguages] = useState(false);

    const [levels, setLevels] = useState([]);
    const [level_, setLevel_] = useState(null);
    const [openLevel, setOpenLevel] = useState(false);

    const [typeScores, setTypeScores] = useState(type_scores);
    const [typeScore, setTypeScore] = useState(0);
    const [openTypeScore, setOpenTypeScore] = useState(false);

    const [initialCodes, setInitialCodes] = useState([]);
    const [solutionCodes, setSolutionCodes] = useState([]);
    const [fullCodes, setFullCodes] = useState([]);

    const [inputTestcase, setInputTestcase] = useState('');
    const [outputTestcase, setOutputTestcase] = useState('');

    const [testcases, setTestcases] = useState([]);

    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [timeLimit, setTimeLimit] = useState();
    const [retries, setRetries] = useState();

    const handleOpenFieldForms = (index) => {
        const updateOpens = [...openFieldForms];
        updateOpens[index] = !updateOpens[index];
        setOpenFieldForms(updateOpens);
    };

    const handleChangeRetries = (_retries) => {
        setRetries(_retries);
    };

    useEffect(() => {
        setOpenFieldForms(new Array(100).fill(true));
        setInitialCodes(new Array(100).fill(''));
        setTheme(localStorage.getItem('theme'));

        (async () => {
            const fetchLanguages = await getAllLanguages();
            setLanguages(fetchLanguages.data);

            const fetchLevels = await getAllLevels();
            setLevels(fetchLevels);
        })();
    }, []);

    return (
        <div className={clsx(styles.editCourseSetting)}>
            <div className={clsx(styles.header)}>Update Exercise</div>
            <div className={clsx(styles.body)}>
                <div className={clsx(styles.block)}>
                    <div
                        className={clsx(styles.blockHeader)}
                        onClick={() => {
                            handleOpenFieldForms(0);
                        }}
                    >
                        <div className={clsx(styles.dropdown)}>
                            {openFieldForms[0] && <FontAwesomeIcon icon={faAngleUp} />}
                            {!openFieldForms[0] && <FontAwesomeIcon icon={faAngleDown} />}
                        </div>
                        <div className={clsx(styles.title)}>Timer</div>
                    </div>
                    {openFieldForms[0] && (
                        <div className={clsx(styles.blockInputField)}>
                            <div className={clsx(styles.formInput)}>
                                <div className={clsx(styles.label)}>
                                    Start Time{' '}
                                    <span>
                                        <FontAwesomeIcon icon={faCircleExclamation} />
                                    </span>
                                </div>
                                <div className={clsx(styles.input)}>
                                    <DateTimePicker onChange={setStartTime} value={startTime} />
                                </div>
                            </div>
                            <div className={clsx(styles.formInput)}>
                                <div className={clsx(styles.label)}>
                                    End Time
                                    <span>
                                        <FontAwesomeIcon icon={faCircleExclamation} />
                                    </span>
                                </div>
                                <div className={clsx(styles.input)}>
                                    <DateTimePicker onChange={setEndTime} value={endTime} />
                                </div>
                            </div>
                            <div className={clsx(styles.formInput)}>
                                <div className={clsx(styles.label)}>
                                    Time Limit
                                    <span>
                                        <FontAwesomeIcon icon={faCircleExclamation} />
                                    </span>
                                </div>
                                <div className={clsx(styles.input)}>
                                    <TimePicker onChange={setTimeLimit} value={timeLimit} />
                                </div>
                            </div>
                            <div className={clsx(styles.formInput)}>
                                <div className={clsx(styles.label)}>
                                    Retries
                                    <span>
                                        <FontAwesomeIcon icon={faCircleExclamation} />
                                    </span>
                                </div>
                                <div className={clsx(styles.input)}>
                                    <input
                                        type="number"
                                        className={clsx('form-control', styles.formControl)}
                                        id="exampleFormControlInput1"
                                        value={retries}
                                        onChange={(event) => handleChangeRetries(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const EditCourseSetting = () => {
    return <CourseViewDetailComponent state="settings" mainChild={<MainChild />} />;
};

export default EditCourseSetting;
